export function breakColumnLabel(
  priceHeader: string,
  breakValue: string,
): string {
  const label = breakValue.trim() === '' ? '(blank)' : breakValue.trim();
  return `${priceHeader} (${label})`;
}

function parseBreakNumber(value: string): number | null {
  const trimmed = value.trim().replace(/,/g, '');
  if (trimmed === '') return null;
  const parsed = Number(trimmed);
  return Number.isFinite(parsed) ? parsed : null;
}

export function compareBreakValues(left: string, right: string): number {
  const leftNumber = parseBreakNumber(left);
  const rightNumber = parseBreakNumber(right);
  if (
    leftNumber !== null &&
    rightNumber !== null &&
    leftNumber !== rightNumber
  ) {
    return leftNumber - rightNumber;
  }
  if (leftNumber !== null && rightNumber === null) return -1;
  if (leftNumber === null && rightNumber !== null) return 1;
  return left.localeCompare(right, undefined, {
    numeric: true,
    sensitivity: 'base',
  });
}

export function sortBreakValues(values: readonly string[]): string[] {
  return [...values].sort(compareBreakValues);
}
